export default {
  medTypes: [
    { type: "allergy#rx=rx", title: "Allergy (Rx)" },
    { type: "allergy#rx=otc", title: "Allergy (OTC)" },
    { type: "anesthetic", title: "Anesthetic" },
    { type: "antibiotic", title: "Antibiotic" },
    { type: "combo", title: "Antibiotic/Steroid" },
    { type: "antifungal", title: "Antifungal" },
    { type: "antiviral", title: "Antiviral" },
    { type: "corticosteroid", title: "Corticosteroid" },
    { type: "dry_eye#rx=rx", title: "Dry Eye (Rx)" },
    { type: "lubricant", title: "Dry Eye (OTC)" },
    { type: "cyclo_mydriatic", title: "Cyclo/Mydriatic" },
    { type: "dye", title: "Dyes" },
    { type: "glaucoma", title: "Glaucoma" },
    { type: "homeopathic", title: "Homeopathic" },
    { type: "hypertonicity", title: "Hypertonicity" },
    // { type: "immunomodulator", title: "Immunomodulator" },
    // { type: "lubricant", title: "Lubricant" },
    { type: "NSAID", title: "NSAID" },
    { type: "vasoconstrictor", title: "Vasoconstrictor" },
    { type: "other", title: "Other" },
  ],
  oralMedTypes: [
    { type: "antibiotic", title: "Antibiotic" },
    { type: "antifungal", title: "Antifungal" },
    { type: "antiviral", title: "Antiviral" },
    { type: "glaucoma", title: "Glaucoma" },
    { type: "opioid", title: "Opioid Analgesic" },
  ],
  titleForCategoryType(category, oral = false) {
    let rtn = null;
    let types = oral ? this.medTypes : this.oralMedTypes;
    for (const typeObj of types) {
      let typeName = typeObj.type;
      if (typeName.includes(category)) rtn = typeObj.title;
    }
    return rtn;
  },
};
